import React from 'react';
import { Formik, } from "formik";
import { FiStar } from "react-icons/fi";
import {Languages} from "./languages"
import { Skillset } from './skillset';
import {Featuring} from './feature'
import { UploadImages } from '../../../@shared/image_upload'
import Navbar from '../../../@shared/navigations/default';
const ProfileUpdatePage = ({ type, bg, newType='user-edit', formRef, giveHand})=>{
    const value = {};
    const options = [
        {name: 'Select', value: '0'},
    ];

    const openFeature = ({name,type}) => {}
    
    const [images,setImages] = React.useState([])

    return  (
    <React.Fragment>
        <title>Create Profile</title>
        <Navbar />

         <div className="">
           <div className="profile-page bg-gray"  >
                <div className="create-page    
                bg-transparent- m900 ">
                    <div className='flex items-center justify-center'>
                        <div>
                            <Formik
                            innerRef={formRef}
                                initialValues={{ 
                                    type: type||options[0].value, 
                                }}
                                onSubmit={async (values, { setSubmitting, resetForm }) => { 
                                    setTimeout(() => {
                                        setSubmitting(false);
                                    }, 1000);
                                }}
                                >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    setFieldValue,
                                    handleSubmit,
                                    isSubmitting,
                                }) => (
                                    <form onSubmit={handleSubmit}>
                                        <div className={`${bg?'profile-create':'nobg'}`}>
                                            <div className="row">
                                                <div className="col-6"> 
                                                    <label htmlFor="">Type {value?.mode ? 'Ok':'None'} </label>
                                                    {/**
                                                     * <SelectSearch 
                                                        options={options} 
                                                        placeholder="Type" 
                                                        name="type"
                                                        aria-label="type"
                                                        label="type"
                                                        onChange={(val)=>{setFieldValue('type',val)}}
                                                        value={values.type}
                                                        // default={''}
                                                    />
                                                    */}
                                                </div>
                                            </div>

                                            <ul>
                                                <li className="flex">
                                                    <div className="profile_component">
                                                        {/* <ChooseComponent 
                                                            type={newType} 
                                                        /> */}
                                                    </div>
                                                </li> 
                                                    
                                                
                                            </ul>



                                            <ul>
                                                <li>
                                                    <div className="profile_component">
                                                        <div className="flex-end"><div className="flex" onClick={openFeature}> <p>Add Skill</p> <div className="open-button"> <FiStar /> </div> </div></div>
                                                        <Featuring data={[]} title="Educations" type={`${newType}-edu`} setFieldValue={setFieldValue} />
                                                        <div className="flex-end"><div className="flex" onClick={()=>openFeature({name:'Educational knowledge', type:`${newType}-edu`})}> <p>Add education</p> <div className="open-button"> <FiStar /> </div> </div></div>
                                                        <Featuring data={[]} title="Experiments" type={`${newType}-exp`} setFieldValue={setFieldValue} />
                                                        <div className="flex-end"><div className="flex" onClick={()=>openFeature({name:'Education', type:`${newType}-exp`})}> <p>Add experiment</p> <div className="open-button"> <FiStar /> </div> </div></div>
                                                    </div>
                                                </li>
                                            </ul>


                                            <Skillset 

                                                type={newType}
                                            />

                                        
                                            <div className="profile_component">
                                                <Languages type={newType} />
                                            </div>


                                            {!giveHand && (
                                            <div className="">
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className="form-group">
                                                            <button type="submit" className="button primary float-right" >Update</button>
                                                        </div>    
                                                    </div>
                                                </div>
                                            </div>
                                            )}


                                        <div className="profile-create mt-3">
                                            <UploadImages 
                                                images={images}
                                                setImages={setImages}
                                            />
                                        </div>
                                        {/** 
                                        

                                            */}
                                        </div>
                                    </form>
                                    )}
                                </Formik>
                            </div>
                    </div>
                </div>
           </div>
        </div>


       
    </React.Fragment>
    )
} 

export default ProfileUpdatePage; 

